import { render } from "./Scrk.vue?vue&type=template&id=b12bb9ec"
import script from "./Scrk.vue?vue&type=script&lang=js"
export * from "./Scrk.vue?vue&type=script&lang=js"

import "./Scrk.vue?vue&type=style&index=0&id=b12bb9ec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__